import React, { useState, useEffect} from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import Menu from '../../components/sturtural/Menu';
import { useNavigate } from 'react-router-dom';
import { storage } from '../../helpers/storage';

const ReporteNivelMunicipioPdf = () => {
    const navigate = useNavigate();

    const [regioneles, setRegiones] = useState(null);
    const [loading_resgionales, setLoading_regionales] = useState(false);
	const [error_regionales, setErrors_regionales] = useState(false);
    const [regional, setRegional] = useState(-1);

    const perfil =  storage.get('perfilid');

    useEffect(() => {
        if(![1, 3, 4].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    
    let url = `https://ventanilla.sec.gob.mx/api/uniformes/genera`;
    useEffect(() => {
        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
				"Accept": "application/json",
				"Access-Control-Allow-Origin": "*"
            },
        }).then(res => {
            let response = res.response;
            if(response == 'on') {
                console.log("PDF GENERADO...");
            }
        });
    },[url]);

    return (
        <>
            <Menu link='reporte-general' />

            <div className="col-12">
                <div className="card">
                    <i className='pi pi-file-pdf mb-5'>REPORTE DE AVANCES</i>
                    <iframe
                        title=""
                        width="100%"
                        height="1024"
                        src={`https://ventanilla.sec.gob.mx/uniformes/AlumnosEnt.pdf`}>
                    </iframe>
                </div>
            </div>
        </>
        
    );
}

export default ReporteNivelMunicipioPdf;